export default __webpack_public_path__ + "static/media/huawei-appgallery-badge.8f003f89.png";